import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	gender: null,
	error: "",
	loading: false,
};

// ADD_gender
export const addGender = createAsyncThunk(
	"gender/addGender",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `gender`,
				data: {
					...values,
				},
			});
			toast.success("Gender added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Gender try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_gender
export const deleteGender = createAsyncThunk(
	"gender/deleteGender ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `gender/${id}`,
			});

			toast.success("Gender deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting gender try again");
			console.log(error.message);
		}
	}
);

// genderS
export const getAllGender = createAsyncThunk(
	"gender/getAllGender",
	async () => {
		try {
			const { data } = await axios.get(`gender`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateGender = createAsyncThunk(
	"gender/updateGender",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `gender/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Gender updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Gender try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const genderSlice = createSlice({
	name: "gender",
	initialState,
	reducers: {
		clearGender: (state) => {
			state.gender = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllGender ======

		builder.addCase(getAllGender.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllGender.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllGender.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addGender  ======

		builder.addCase(addGender.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addGender.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addGender.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for gender ======

		builder.addCase(updateGender.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateGender.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateGender.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteGender  ======

		builder.addCase(deleteGender.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteGender.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteGender.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default genderSlice.reducer;
export const { clearGender } = genderSlice.actions;
